import { t } from "ttag";

import { MODAL_ROUTES, useNavigateModal } from "@/app/router";
import type {
  DocumentFolder,
  UploadedFile,
} from "@/shared/models/legacy-types";
import {
  DropdownMenu,
  IconWrapper,
  MenuDotsIcons,
  PenIcon,
  TrashBin2Icon,
} from "@/shared/ui";

interface EditActionsProps {
  folder: DocumentFolder;
  fileId: UploadedFile["id"];
  vendor?: string | null;
}

export const EditActions = ({ folder, fileId, vendor }: EditActionsProps) => {
  const navigateModal = useNavigateModal();
  const vendorParam = vendor ? `?vendor=${encodeURIComponent(vendor)}` : "";
  return (
    <DropdownMenu.Root modal={false}>
      <DropdownMenu.Trigger className="flex rotate-90 items-center justify-center p-1 text-primary-900 focus:outline-secondary-200">
        <MenuDotsIcons className="size-4" />
      </DropdownMenu.Trigger>
      <DropdownMenu.Content align="end">
        <DropdownMenu.Item
          onClick={() =>
            navigateModal(
              `${MODAL_ROUTES.DOCUMENT_CENTER.EDIT_DOCUMENT}/${folder}/${fileId}${vendorParam}`,
            )
          }
          className="gap-2"
        >
          <IconWrapper size="sm" className="text-neutral-800">
            <PenIcon />
          </IconWrapper>
          {t`Edit document name`}
        </DropdownMenu.Item>
        <DropdownMenu.Separator />
        <DropdownMenu.Item
          onClick={() =>
            navigateModal(
              `${MODAL_ROUTES.DOCUMENT_CENTER.REMOVE_DOCUMENT}/${folder}/${fileId}${vendorParam}`,
            )
          }
          className="gap-2"
        >
          <IconWrapper size="sm" className="text-neutral-800">
            <TrashBin2Icon />
          </IconWrapper>
          {t`Remove document`}
        </DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};
